let PackagesItem = [
    {
        id: 1,
        trackTitle: "Full Access 🔥",
        trackSubtitle: "for experienced Data Science Developers",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'On-demand recordings of the event',
        trackLink: 'https://geekle.us/ticket/1647606893926x216249837041745920',
    },
    {
        id: 2,
        trackTitle: "Beginner Track",
        trackSubtitle: "for Data Science Developers",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Q&A of the Beginner Track',
        trackLink: 'https://geekle.us/ticketfree/1647607318659x118165313426292740',
    },
  ];
  
  export default PackagesItem;
  